
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {


  return (
    <section id="contact" className="section contact">
      <div className="container">
        <motion.div 
          className="contact-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>Contact Us</h2>
          <p>Let’s start your project the right way—with a conversation.</p>
          <p>Reach out to our team for consultations, quotes, or any queries.</p>
        </motion.div>

        <motion.div 
          className="contact-details"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-label">📞 Akhila:</span>
              <span className="contact-value">+91 83749 99533</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">📧 Email:</span>
              <span className="contact-value">info.10designs@gmail.com</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">📍 Address:</span>
              <span className="contact-value">Villa 151, Saket Bhu Satva, Kompally, Hyderabad</span>
            </div>
          </div>
          
          <motion.button 
            className="whatsapp-btn"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            onClick={() => window.open('https://wa.me/918374999533', '_blank')}
          >
            <FaWhatsapp />
            Chat on Whatsapp
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact; 